module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/90/assets/images/fa2cfffe42543a5aa862fb8e0d46e2da.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Gold/Gold1.svg
// module id = ShFx
// module chunks = 1